
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { cn } from "@/lib/utils";
import TicketList from './tickets/TicketList';
import { Ticket } from "lucide-react";

interface TicketsSectionProps {
  standalone?: boolean;
}

const TicketsSection = ({ standalone = false }: TicketsSectionProps) => {
  const [forceRender] = useState(Date.now());
  const [updateCount] = useState(0);

  return (
    <section id="tickets" className={cn("py-16 md:py-24", standalone ? "pt-0" : "")}>
      {standalone && (
        <div className="relative py-16 md:py-24 overflow-hidden bg-gradient-to-b from-purple-900/80 to-black">
          <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
            <div className="absolute w-full h-[40%] bottom-0 bg-gradient-to-t from-black to-transparent"></div>
            <div className="absolute w-full h-[500px] bottom-0 left-0 right-0">
              <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
                <path 
                  fill="#000000" 
                  fillOpacity="1" 
                  d="M0,128L48,138.7C96,149,192,171,288,176C384,181,480,171,576,144C672,117,768,75,864,80C960,85,1056,139,1152,160C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                ></path>
              </svg>
            </div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center max-w-4xl mx-auto animate-fade-in">
              <div className="inline-flex items-center justify-center gap-2 py-2 px-4 bg-yellow-400 backdrop-blur-sm rounded-full border border-yellow-500 mb-8">
                <Ticket className="h-5 w-5 text-black animate-bounce-subtle" />
                <span className="text-black font-medium">Choose Your Passes</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold mb-8">
                <span className="text-white">Book </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-white animate-pulse">Tickets</span>
                <span className="text-white"> Now!</span>
              </h1>
              
              <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
                2026 Dates: November 25th-26th, London, UK Europe. Book now and secure you tickets to network and experience the cutting edge of artificial intelligence at AI World Congress 2026
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 md:px-6">
        {!standalone && (
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="text-purple-400 font-medium mb-3">Tickets & Registration</h2>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F97316] to-[#FEF7CD] mb-6">
              Secure Your Spot Today
            </h3>
            <p className="max-w-3xl mx-auto text-lg text-gray-300 mb-6">
              2026 Dates: November 25th-26th, London, UK Europe. Book now and secure you tickets to network and experience the cutting edge of artificial intelligence at AI World Congress 2026
            </p>
            <Link to="/register">
              <Button 
                className="mb-12 text-lg px-8 py-6 bg-gradient-to-r from-[#F97316] to-[#ea384c] hover:opacity-90 text-white font-semibold shadow-lg animate-pulse"
              >
                Register Now
              </Button>
            </Link>
          </div>
        )}

        <TicketList forceRender={forceRender} updateCount={updateCount} />
        
        {/* Added VAT notice */}
        <p className="text-center mt-6 text-gray-400">All prices subject to 20% VAT Tax.</p>
      </div>
    </section>
  );
};

export default TicketsSection;
